<template>
  <nv-page header="Bulk Proposals" data-cy="hierarchy-bulk-reviews-list">
    <template slot="toolbar">
      <v-spacer />
      <filter-sheet ref="filter-sheet" @changed="setTableSettings" />
      <nv-table-search v-model="search" sync class="ml-4" />
    </template>

    <template #filters>
      <nv-table-filters
        ref="applied-filters"
        :value="tableFilters"
        @clear="$refs.filters.clearFilters()"
      >
        <proposals-filter-sheet
          v-if="isAll"
          ref="filters"
          :bulk="true"
          @changed="setTableFilters"
        />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="extendedItems"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item="{ item }">
        <bulk-review-row :item="item" mv @open-form="openForm" />
      </template>
    </v-data-table>
    <bulk-review-form :id="form.id" v-model="form.show" link @saved="tableFetch" />
  </nv-page>
</template>

<script>
import HTTP from '@/api/ant';
import { TableMixin } from '@nielsen-media/ui-toolkit-vue-api';
import FilterSheet from '@/components/mv/proposals/FilterSheet';
import BulkReviewForm from '@/components/cls/BulkReviewForm.vue';
import BulkReviewRow from '@/components/BulkReviewRow';
import ProposalsFilterSheet from '@/components/mv/proposals/ProposalsFilterSheet';
import { extendProposalsItems } from '@/helpers/owlFind.js';

const headers = [
  { text: 'Type', sortable: false, value: 'kind' },
  { text: 'Tree Id', sortable: false, value: 'tree_id' },
  { text: 'Market', sortable: false, value: 'localization' },
  { text: 'Process Type', sortable: false, value: 'process_type' },
  { text: 'Status', sortable: false, value: 'status' },
  { text: 'Created By', sortable: false, value: 'created_by' },
  { text: 'Updated At', sortable: false, value: 'updated_at' },
];

export default {
  components: { ProposalsFilterSheet, BulkReviewRow, BulkReviewForm, FilterSheet },
  mixins: [TableMixin],
  data: () => ({
    headers,
    expanded: {},
    extendedItems: [],
    form: {
      show: false,
      id: null,
    },
    settings: {},
    savedTableFilters: {},
    table: {
      sortBy: ['updated_at'],
      sortDesc: [true],
    },
  }),
  computed: {
    isAll() {
      return Object.keys(this.settings).length === 0;
    },
  },
  watch: {
    settings(cur, prev) {
      if (this.isAll) {
        this.tableFilters = { ...this.savedTableFilters };
      } else if (Object.keys(prev).length === 0) {
        this.savedTableFilters = { ...this.tableFilters };
        this.tableFilters = {};
      }
      this.tableFetch();
    },
  },
  methods: {
    tableFetch() {
      this.paginateTableData(HTTP, '/bulk_upload/processes')
        .then(async ({ data }) => {
          if (data.length) {
            this.loading = true;
            const groupedData = data.reduce((acc, item) => {
              let country_key = item?.localization || '*';
              if (!acc[country_key]) {
                acc[country_key] = [];
              }
              acc[country_key].push(item);
              return acc;
            }, {});

            const promises = Object.entries(groupedData).map(([countryCode, items]) =>
              extendProposalsItems(items, 'bulk', countryCode).then(result => ({
                countryCode,
                result,
              })),
            );

            const results = await Promise.all(promises);
            this.extendedItems = results.reduce((acc, { result }) => {
              return acc.concat(result);
            }, []);
          }
          this.extendedItems.sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openForm(item) {
      this.form.id = item.id;
      this.form.show = true;
    },
    setTableSettings(settings) {
      this.settings = settings;
    },
  },
};
</script>
